import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMarketoComponent } from './simple-icons-marketo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMarketoComponent ],
    exports:      [ SimpleIconsMarketoComponent ],
    bootstrap:    []
})
export class SimpleIconsMarketoModule {}
